export default __webpack_public_path__ + "images/assets/5ca767a7d94e246a404d9ef933f228ce.svg";